<template>
  <div :class="$style['pt-fast-loan-audit-table']">
       <wt-paged-table :on-request-data="getTableData" :total-size="totalNumber" layout="total,sizes, prev, pager, next,jumper" :pageSizes="[10, 20, 50, 200]"
      :page-size="pageSize" ref="table" isAddPageToRouter :isOutside="isOutside">
        <wt-table :labels="tableLabels"  ref="tables" :list="tableData" >
            <slot/>
        </wt-table>
       </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'pt-fast-loan-audit-table'
export default {
  name: 'pt-fast-loan-audit-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 10
    },
    isOutside: {
      type: Boolean,
      default: false
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    tableData: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next, size) {
      this.$emit('getTableData', page, next, size)
    }

  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-fast-loan-audit-table{
    :global
    .el-button{
        margin-left: 0;
        margin-right: 10px;
    }
}
</style>
